import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { Typography } from '@material-ui/core'

import {
  Button,
  DialogConfirm,
} from 'ui/components'

import {
  deletePlan,
} from 'services/apiMotorBgc'

import styles from './styles'

export default ({ docType, plan, onSubmit = null }) => {
  const classes = styles()

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)

  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleToggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const handleCancel = () => {
    setModalOpen(false)
  }

  const handlePlanDelete = async () => {
    setLoading(true)

    try {
      await deletePlan(
        apiKey,
        userId,
        docType,
        plan.plan_id,
      )
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao deletar plano'
      toast.error(messageError)
      setLoading(false)
      return
    }

    setLoading(false)
    setModalOpen(false)
    toast.success('Plano deletado com sucesso!')

    if (_.isFunction(onSubmit)) onSubmit()
  }

  const renderPlanName = () => {
    return (
      <Typography>
        <strong>Nome:</strong>
        {' '}
        <span>{plan.name}</span>
      </Typography>
    )
  }

  const renderText = () => {
    return (
      <Typography>
        Não será mais possivel criar novas consultas com este plano, consultas processando ou processadas não são afetadas. Deseja deletar?
      </Typography>
    )
  }

  const renderContent = () => {
    if (_.isEmpty(plan)) return null

    return (
      <div className={classes.contentContainer}>
        {renderPlanName()}
        {renderText()}
      </div>
    )
  }

  return (
    <div>
      <Button
        variant="outlined"
        size="small"
        onClick={handleToggleModal}
      >
        Deletar
      </Button>

      <DialogConfirm
        title="Deletar Plano"
        open={modalOpen}
        onCancel={handleCancel}
        onConfirm={handlePlanDelete}
        content={renderContent()}
        btnConfirmDisabled={loading}
        btnConfirmText="Deletar"
        btnCancelText="Cancelar"
      />
    </div>
  )
}
